export default "__VITE_ASSET__CdqFB0KI__"